import * as React from 'react';
import { companyConfig } from '../config/colors';

interface EmailFooterV2Props {
  variant?: 'clean' | 'minimal' | 'simple';
  showContactInfo?: boolean;
  showLinks?: boolean;
}

export const EmailFooterV2: React.FC<EmailFooterV2Props> = ({
  variant = 'clean',
  showContactInfo = false,
  showLinks = false,
}) => {
  const currentYear = new Date().getFullYear();

  if (variant === 'minimal') {
    return (
      <td
        className="footer-minimal"
    align="center"
    style={{
          padding: "16px 20px",
          backgroundColor: "#ffffff",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{
            margin: "0",
            fontSize: "11px",
            color: "#999999",
            lineHeight: "1.4",
          }}>
            © {currentYear} {companyConfig.name}
          </p>
              </div>
            </td>
    );
  }

  if (variant === 'simple') {
    return (
      <td
        className="footer-simple"
        align="center"
        style={{
          padding: "20px",
          backgroundColor: "#fafafa",
          borderTop: "1px solid #eeeeee",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "500px", margin: "0 auto" }}>
          <div style={{ marginBottom: "12px" }}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ opacity: 0.6 }}
            >
              <path
                fill="#737373"
                d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z"
              />
            </svg>
          </div>
          <p style={{
            margin: "0 0 8px",
            fontSize: "12px",
            color: "#666666",
          }}>
            © {currentYear} {companyConfig.name}
          </p>
          {showLinks && (
            <div style={{
              fontSize: "11px",
              color: "#999999",
            }}>
              <a href={`https://${companyConfig.domain}/termos`} style={{
                color: "#999999",
                textDecoration: "none",
                marginRight: "12px",
              }}>
                Termos
              </a>
              <a href={`https://${companyConfig.domain}/privacidade`} style={{
                color: "#999999",
                textDecoration: "none",
              }}>
                Privacidade
              </a>
            </div>
          )}
        </div>
      </td>
    );
  }

  // Clean variant (default) - Versão simplificada e compatível com Gmail
  return (
    <td
      className="footer-clean"
      align="center"
      style={{
        padding: "32px 20px",
        backgroundColor: "#f0f0f0",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* Layout centralizado e simples */}
      <table
        cellPadding="0"
        cellSpacing="0"
        border={0}
        style={{
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {/* Seção de contato */}
        <tr>
          <td style={{ textAlign: "center", paddingBottom: "20px" }}>
            <div style={{
              fontSize: "14px",
              color: "#1F1746",
              marginBottom: "12px",
              fontWeight: "bold",
            }}>
              Precisa de ajuda? 🤝 Entre em contato conosco:
            </div>
            <div style={{ marginBottom: "8px" }}>
              <a href={`mailto:${companyConfig.supportEmail}`} style={{
                color: "#737373",
                textDecoration: "none",
                fontSize: "13px",
                marginRight: "20px",
              }}>
                📧 {companyConfig.supportEmail}
              </a>
              <a href={`https://wa.me/55${companyConfig.phone.replace(/\D/g, '')}`} style={{
                color: "#737373",
                textDecoration: "none",
                fontSize: "13px",
              }}>
                📱 {companyConfig.phone}
              </a>
            </div>
          </td>
        </tr>

        {/* Seção de redes sociais */}
        <tr>
          <td style={{ textAlign: "center", paddingBottom: "20px" }}>
            <div style={{
              fontSize: "13px",
              color: "#737373",
              marginBottom: "12px",
            }}>
              Siga a Trivium nas redes sociais:
            </div>
            <table cellPadding="0" cellSpacing="0" border={0} style={{ margin: "0 auto" }}>
              <tr>
                {/* Instagram */}
                <td style={{ padding: "0 4px" }}>
                  <a href="https://instagram.com/trivium" style={{ textDecoration: "none" }}>
                    <img 
                      src="https://cdn-icons-png.flaticon.com/512/174/174855.png"
                      alt="Instagram"
                      width="20"
                      height="20"
                      style={{
                        display: "block",
                        border: "none",
                        borderRadius: "3px",
                      }}
                    />
                  </a>
                </td>

                {/* Facebook */}
                <td style={{ padding: "0 4px" }}>
                  <a href="https://facebook.com/trivium" style={{ textDecoration: "none" }}>
                    <img 
                      src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                      alt="Facebook"
                      width="20"
                      height="20"
                      style={{
                        display: "block",
                        border: "none",
                        borderRadius: "3px",
                      }}
                    />
                  </a>
                </td>

                {/* LinkedIn */}
                <td style={{ padding: "0 4px" }}>
                  <a href="https://linkedin.com/company/trivium" style={{ textDecoration: "none" }}>
                    <img 
                      src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                      alt="LinkedIn"
                      width="20"
                      height="20"
                      style={{
                        display: "block",
                        border: "none",
                        borderRadius: "3px",
                      }}
                    />
                  </a>
                </td>

                {/* YouTube */}
                <td style={{ padding: "0 4px" }}>
                  <a href="https://youtube.com/@trivium" style={{ textDecoration: "none" }}>
                    <img 
                      src="https://cdn-icons-png.flaticon.com/512/733/733646.png"
                      alt="YouTube"
                      width="20"
                      height="20"
                      style={{
                        display: "block",
                        border: "none",
                        borderRadius: "3px",
                      }}
                    />
                  </a>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        {/* Separador e Copyright */}
        <tr>
          <td style={{
            borderTop: "1px solid #e0e0e0",
            paddingTop: "16px",
            textAlign: "center",
          }}>
            <p style={{
              margin: "0",
              fontSize: "13px",
              color: "#737373",
              lineHeight: "1.4",
            }}>
              © {currentYear} {companyConfig.name}. Todos os direitos reservados.
            </p>
          </td>
        </tr>
      </table>
    </td>
);
};

export default EmailFooterV2;
